/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.reactions.add': 'Dodaj reakcję',
  'fabric.reactions.error.unexpected': 'Reakcje są tymczasowo niedostępne',
  'fabric.reactions.loading': 'Ładowanie...',
  'fabric.reactions.more.emojis': 'Więcej emoji',
  'fabric.reactions.other.reacted.users':
    '{count, plural, one {i jeszcze 1} few {i jeszcze {count}} many {i jeszcze {count}} other {i jeszcze {count}}}',
  'fabric.reactions.reactwithemoji': 'Zareaguj za pomocą emoji {emoji}',
  'fabric.reactions.summary': 'Wyświetl wszystkie reakcje użytkowników',
  'reaction-picker-trigger.add.reaction.message': 'Dodaj reakcję',
  'reactions.dialog.close': 'Zamknij',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Przejdź w lewo',
  'reactions.dialog.reactions.count':
    '{count, plural, one {Łącznie {count,number} reakcja} few {Łącznie {count,number} reakcje} many {Łącznie {count,number} reakcji} other {Łącznie {count,number} reakcji}}',
  'reactions.dialog.right.navigate': 'Przejdź w prawo',
  'reactions.dialog.viewall': 'Wyświetl wszystkich',
  'reactions.dialog.viewall.tooltip': 'Wyświetl wszystkie reakcje użytkowników',
};
